import axios from "axios";
import Base64 from './base64';

window.isDoingLogin = false;
export default {
	install(Vue, options) {
		Vue.prototype.$command = {
			execute: this.execute
		}
	},
	async execute(option = {
		api,
		parameter,
		exportCfg
	}) {
		var header = {
			"content-type": "application/json",
            "identity":localStorage.getItem('identity')||''
		};
		if (option.exportCfg) {
			var base64 = new Base64()
			var exportStr = base64.encode(JSON.stringify(option.exportCfg));
			header.exportCfg = exportStr
		}
		let response = await axios
			.post(option.api, option.parameter, {
				headers: header
			});

		return new Promise((resolve, reject) => {
			if (response.data.code == 0) {
				//success
				if (option.exportCfg) {
					window.open(response.data.data);
				}

				resolve(response.data);
				return;
			}
			if (response.data.code == 5 && !window.isDoingLogin) {
				window.isDoingLogin = true;
				//未登录
				if (confirm('请先登录')) {
					//保存当前地址，登陆成功后将跳转到此处
					var gotoUrl = window.sessionStorage.getItem("goto-url");
					if (!gotoUrl) {
						window.sessionStorage.setItem("goto-url", location.href);
					}
					location.replace('/login');
				}
			}
			return reject(response.data);
		})
	}
}
